(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ta-shop-tabs"] && !Shopify.designMode) return;
  try {
    (function(){document.addEventListener('click',function(e){var t=e.target.closest('.ta-tabs__tab');if(!t)return;var r=t.closest('[data-ta-tabs]');r.querySelectorAll('.ta-tabs__tab').forEach(function(x){x.setAttribute('aria-selected',x===t?'true':'false')});r.querySelectorAll('.ta-tabs__panel').forEach(function(p){p.hidden=p.id!==t.getAttribute('aria-controls');if(!p.hidden)p.querySelectorAll('.ta-reveal').forEach(function(c){c.classList.add('is-in')})})});document.addEventListener('shopify:block:select',function(e){var t=e.target.closest&&e.target.closest('.ta-tabs__tab');if(t)t.click()})})();
  } catch(e) { console.error(e); }
})();
})();
